import React from 'react';
import Layout from '../layout/Layout';
import { Grid, Typography, Link, Alert } from '@mui/material';
import { FaDownload } from 'react-icons/fa';
import './descargas.css';

function Descargas(props) {
    return (
        <Layout tyExpanded={props.tyExpanded} setExpanded={props.setExpanded}>
            <Grid style={{ display: 'flex', flexDirection: 'column', gap: '35px', padding: '2rem 5.8rem' }}>
                <Typography style={{ color: 'white', fontSize: '20px', display: 'flex', gap: '5px', alignItems: 'center', marginBottom: '20px', textAlign: 'justify' }}>
                    <FaDownload style={{ color: '#ffc107' }} />
                    Descargas
                </Typography>
                <div className="usersettings-settings">
                    <div className="usersettings-change-avatar">
                        <Typography style={{ color: 'white', marginBottom: '20px', textAlign: 'justify' }}>
                            ¡Bienvenido a nuestra sección de descargas! Aquí encontrarás los archivos necesarios para comenzar tu aventura en el continente de Mu Serendipia. Sigue las instrucciones del instalador para una correcta instalación del juego.
                        </Typography>
                    </div>
                    <div className="usersettings-change-avatar">
                        <Alert severity="warning" style={{ marginBottom: '20px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', textAlign: 'justify' }}>
                                <Typography>Para garantizar la seguridad de tu equipo, te recomendamos descargar el cliente únicamente desde los enlaces proporcionados en esta sección. Evita descargar desde otras fuentes.</Typography>
                            </div>
                        </Alert>
                    </div>
                    <div className="usersettings-change-avatar">
                        <Typography style={{ color: 'white', textAlign: 'justify' }}>Descargar desde:</Typography>
                        <div className="download-links">
                            <button className="download-button">
                                <Link href="https://www.mediafire.com/file/lpa7mx49yuw96ae/MuSerendipia(Beta).exe/file" target="_blank" rel="noopener noreferrer">Mediafire</Link>
                            </button>
                            <button className="download-button">
                                <Link href="https://mega.nz/file/MnlQkIIb#r1_rvDz0ZFGreY4k9U4EeMNDLFmY9r6gZZpav5wuqxQ" target="_blank" rel="noopener noreferrer">Mega</Link>
                            </button>
                        </div>
                    </div>
                </div>
            </Grid>
        </Layout>
    );
}

export default Descargas;
